module.exports = __webpack_public_path__ + "static/media/weadyicon.2d9dfd75.svg";